// client/src/components/ContentPage.js
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

function ContentPage() {
  const { postId } = useParams();
  const [post, setPost] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    // Fetch the post by ID
    let apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    axios.get(`${apiBaseUrl}/posts/${postId}`)
      .then(response => {
        setPost(response.data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching post:', err);
        setError('Failed to fetch post');
        setLoading(false);
      });
  }, [postId]);

  if (loading) return <div>Loading post...</div>;
  if (error) return <div>{error}</div>;
  if (!post) return <div>No post found.</div>;

  return (
    <div style={{ padding: '2rem' }}>
      <h1>{post.title}</h1>
      <p>Posted by: {post.creatorId?.username || 'Unknown'}</p>
      <div dangerouslySetInnerHTML={{ __html: post.content }} />
    </div>
  );
}

export default ContentPage;
